import React from 'react';
import './Arrows.css';
import arrow from '../assets/arrow.png';

export function NextArrow(props) {
  const { onClick } = props;
  return <div className="custom-arrow next" onClick={onClick}>
	<img src={arrow} alt='arrow'/>
  </div>;
}

export function PrevArrow(props) {
  const { onClick } = props;
  return <div className="custom-arrow prev" onClick={onClick}>
	<img src={arrow} alt='arrow'/>
  </div>;
}
